import styled from "styled-components";
import { Box } from "rebass";

export const Section = styled(Box)`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors["sp-gray1"]}`};
`;

Section.defaultProps = {
  as: "section",
  px: ["20px"],
  py: ["9px"],
  backgroundColor: "#fff",
};
